import React from 'react';
import { View } from '../types';
import { AdminUser } from '../api/adminApi';

interface HeaderProps {
  currentView: View;
  searchTerm: string;
  onSearchChange: (term: string) => void;
  user?: AdminUser | null;
  onLogout?: () => void;
}

const Header: React.FC<HeaderProps> = ({ currentView, searchTerm, onSearchChange, user, onLogout }) => {
  const viewTitles: { [key in View]: string } = {
    dashboard: 'דף הבית',
    reports: 'דוחות ומדדים',
    reminderHistory: 'היסטוריית תזכורות',
    appointmentsSummary: 'סיכום תורים',
    services: 'ניהול שירותים רפואיים',
    schedule: 'ניהול לוח זמנים',
    holidays: 'ניהול חגים וסגירות',
    booking: 'קביעת תור',
    drafts: 'תורים לא הושלמו',
    technicians: 'ניהול טכנאים',
  };

  return (
    <header className="bg-white shadow-md p-4 flex justify-between items-center min-w-0 w-full">
      <h2 className="text-xl font-bold text-slate-800 truncate">{viewTitles[currentView]}</h2>
      <div className="flex items-center gap-4 flex-shrink-0">
        {/* <div className="relative">
          <input
            type="text"
            placeholder="חיפוש לפי מספר ת.ז..."
            className="w-64 p-2 ps-10 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <svg className="w-5 h-5 text-slate-400 absolute top-2.5 start-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div> */}

        {/* User Profile */}
        {user && (
          <div className="flex items-center gap-3">
            <div className="text-right">
              <div className="text-sm font-medium text-slate-800">{user.name}</div>
              <div className="text-xs text-slate-500">{user.email}</div>
            </div>
            <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-blue-600 rounded-full flex items-center justify-center text-white text-sm font-bold">
              {user.name.charAt(0)}
            </div>
            {onLogout && (
              <button
                onClick={onLogout}
                className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
                title="התנתקות"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </button>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;